import { useMemo } from 'react'

import { ReactUserAlertsProps } from './types'
import UserAlerts from './UserAlerts/UserAlerts'
import withAEM from '../../hoc/withAEM'

const ReactUserAlerts = (props: ReactUserAlertsProps): JSX.Element => {
  const ReactUserAlertsWithAEM = useMemo(() => withAEM(UserAlerts), [])
  return <ReactUserAlertsWithAEM {...props} compName={'React User Alerts'} />
}
export default ReactUserAlerts
